import React, {useContext} from "react";
import OptionIcon from "../../assets/images/options-black.svg";
import FloContext from "../contexts/floContext";

export default function FolderOptions(props: any) {
   const {onFolderDelete, onEnableFolderEdit}: any = useContext(FloContext);
   const {folder} = props;
   return(
       <div className="options-sec">
          <div className="options-icon flex">
             <div className="icon">
                <img src={OptionIcon} alt=""/>
             </div>
          </div>
          <ul className="options-list" id="folder">
             <li onClick={() => onEnableFolderEdit(folder)}>Rename</li>
             <li onClick={() => onFolderDelete(folder)} className="red-color">Delete</li>
          </ul>
       </div>
   )
}
